const details = resolve => require(['@/pages/business/business/detail'], resolve);
const sellerlv = resolve => require(['@/pages/business/rating'], resolve);
const again = resolve => require(['@/pages/business/revise/again'], resolve);
const reviseactive = resolve => require(['@/pages/business/revise'], resolve);
const sellermge = resolve => require(['@/pages/business/business'], resolve);
const audit = resolve => require(['@/pages/business/settle/audit'], resolve);
const settled = resolve => require(['@/pages/business/settle'], resolve);

export default [
  /*****************商家管理*******************/
  //入驻管理
  {
    path: "/settled",
    name: "入驻管理",
    component: settled
  },
  /*入驻管理下路由开始*/
  {
    path: "/settled/audit/:id/:state",
    name: "入驻审核",
    component: audit
  },
  /*入驻管理下路由结束*/
  //商家管理
  {
    path: "/sellermge",
    name: "商家管理",
    component: sellermge
  },
  //修改审核
  {
    path: "/reviseactive",
    name: "修改审核",
    component: reviseactive
  },
  /*修改审核下路由开始*/
  {
    path: "/reviseactive/again/:id/:state/:modifyId",
    name: "再次审核",
    component: again
  },
  /*修改审核下路由结束*/
  //商家等级
  {
    path: "/sellerlv",
    name: "商家等级",
    component: sellerlv
  },
  {
    path: "/sellerlv/details/:id",
    name: "商家详情",
    component: details
  }
]
